/**
 * Utils for competitor icon.
 *
 * @class CompetitorIconUtils
 * @memberof Mojito.Presentation.Components.CompetitorIcon
 */
export default class CompetitorIconUtils {
    /**
     * Replace colors in an SVG string.
     *
     * @param {string} svgString - SVG string.
     * @param {Array<string>} colors - Array of colors.
     *
     * @returns {string} SVG string with replaced colors.
     */
    static replaceColors = (svgString, colors = []) => {
        const parser = new DOMParser();
        const svgDoc = parser.parseFromString(svgString, 'image/svg+xml');

        colors.forEach((color, index) => {
            const targetClass = `.cls-${index + 1}`;
            const elements = svgDoc.querySelectorAll(targetClass);
            elements.forEach(element => {
                element.style.fill = color.includes('#') ? color : `#${color}`;
            });
        });

        const serializer = new XMLSerializer();
        return serializer.serializeToString(svgDoc);
    };

    /**
     * Encode SVG string to base64.
     *
     * @param {string} svgString - SVG string.
     *
     * @returns {string} Base64 encoded SVG string.
     */
    static encodeSvgString = svgString => {
        return `data:image/svg+xml;utf8,${encodeURIComponent(svgString)}`;
    };
}
